import React/*, { Component }*/ from "react";
import Chat from "./Chat.js";
import ChatUser from "./ChatUser.js";
import AlarmOutline from "../../resources/icons/AlarmOutline.jsx";
import ArrowDownCircleOutline from "../../resources/icons/ArrowDownCircleOutline.jsx";
import ArrowUpCircleOutline from "../../resources/icons/ArrowUpCircleOutline.jsx";
import TimeOutline from "../../resources/icons/TimeOutline.jsx";
import FilterCircleSharp from "../../resources/icons/FilterCircleSharp.jsx";
import CloseCircleSharp from "../../resources/icons/CloseCircleSharp.jsx";
import PeopleCircleSharp from "../../resources/icons/PeopleCircleSharp.jsx";
PeopleCircleSharp;
class ChatForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chatSelected: false,
      chatId: 0,
      isOpened: this.props.isOpened,
      chats: [],
      intervalId: null,
      closeFunc: props.closeFunc,
      sorting: "date",
      filter_date: "Всё",
      filter: "all",
      filter_text: "",
      chatUserName: "",
      showFilter: false,
      showUsersList: true,
      newMessages: 0,
    };
    this.toggleFilter = this.toggleFilter.bind(this);
    this.toggleUsersList = this.toggleUsersList.bind(this);
    this.closeUsersList = this.closeUsersList.bind(this);
  }
  toggleFilter() {
    this.setState({ showFilter: !this.state.showFilter });
  }
  toggleUsersList() {
    this.setState({ showUsersList: !this.state.showUsersList });
  }
  closeUsersList() {
    this.setState({ showUsersList: false });
  }
  selectChat = (chatId, isSelected, userName) => {
    this.setState({
      chatId: chatId,
      chatSelected: true,
      chatUserName: " (" + userName + ")",
    });
  };
  static getDerivedStateFromProps(nextProps/*, prevProps*/) {
    return {
      isOpened: nextProps.isOpened,
      newMessages: nextProps.newMessages,
    };
  }
  componentDidMount() {
    this.loadChatList();
    this.state.intervalId = setInterval(() => {
      if (this.state.isOpened) {
        this.loadChatList();
      }
    }, 5000);
  }

  loadChatList() {
    fetch(this.props.mentorChatApiRoot + "/chat/list", {
      method: "POST",
      cache: "no-cache",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: localStorage.getItem("mentor_chat_token"),
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (!this.state.chatSelected && result.chats.length > 0) {
            this.setState({
              chatId: result.chats[0].chat_id,
              chatSelected: true,
            });
          }
          this.setState({
            chats: result.chats,
          });
        },
        (error) => {
          console.log(error);
        },
      );
  }
  set_sorting(sorting) {
    var my = this;
    return function (/*e*/) {
      console.log(sorting);
      my.setState({
        sorting: sorting,
      });
    };
  }
  set_filter(filter) {
    var my = this;
    return function (/*e*/) {
      my.setState({
        filter: filter,
      });
    };
  }
  set_filter_date(filter) {
    var my = this;
    return function (/*e*/) {
      console.log(filter);
      my.setState({
        filter_date: filter,
      });
    };
  }
  set_filter_text(/*filter*/) {
    var my = this;
    return function (e) {
      my.setState({
        filter_text: e.target.value.toLowerCase(),
      });
    };
  }
  filter_text(user) {
    if (
      user.user_name
        .toLowerCase()
        .indexOf(
          document
            .getElementById("MentorChatUsersFilterInput")
            .value.toLowerCase(),
        ) >= 0
    ) {
      return true;
    }
    if (user.last_message.text) {
      return (
        user.last_message.text
          .toLowerCase()
          .indexOf(
            document
              .getElementById("MentorChatUsersFilterInput")
              .value.toLowerCase(),
          ) >= 0
      );
    } else {
      if (
        document
          .getElementById("MentorChatUsersFilterInput")
          .value.toLowerCase() === ""
      ) {
        return 1;
      } else {
        return 0;
      }
    }
    //document.getElementById("MentorChatUsersFilterInput").ariaValueMax.toLowerCase()
  }
  componentWillUnmount() {
    clearInterval(this.state.intervalId);
  }
  sort_by_user_name_asc(a, b) {
    if (a.user_name < b.user_name) {
      return -1;
    }
    if (a.user_name > b.user_name) {
      return 1;
    }
    return 0;
  }
  sort_by_user_name_desc(a, b) {
    if (a.user_name > b.user_name) {
      return -1;
    }
    if (a.user_name < b.user_name) {
      return 1;
    }
    return 0;
  }
  sort_by_ts(a, b) {
    if (a.last_message.ts < b.last_message.ts) {
      return 1;
    }
    if (a.last_message.ts > b.last_message.ts) {
      return -1;
    }
    return 0;
  }
  sort_by_new_messages(a, b) {
    if (a.new_messages < b.new_messages) {
      return 1;
    }
    if (a.new_messages > b.new_messages) {
      return -1;
    }
    return 0;
  }
  sort_users_list(sorting) {
    switch (sorting) {
      case "abc_asc":
        return this.sort_by_user_name_asc;
      case "abc_desc":
        return this.sort_by_user_name_desc;
      default:
        return this.sort_by_ts;
    }
  }
  filter_by_1d(user) {
    if (user.last_message.ts) {
      return user.last_message.ts * 1000 > Date.now() - 86400000;
    } else {
      return false;
    }
  }
  filter_by_2d(user) {
    console.log(user);
    if (user.last_message.ts) {
      return user.last_message.ts * 1000 > Date.now() - 86400000 * 2;
    } else {
      return false;
    }
  }
  filter_by_7d(user) {
    if (user.last_message.ts) {
      return user.last_message.ts * 1000 > Date.now() - 86400000 * 7;
    } else {
      return false;
    }
  }
  filter_users_list_date(filter) {
    switch (filter) {
      case "1д.":
        return this.filter_by_1d;
      case "2д.":
        return this.filter_by_2d;
      case "7д.":
        return this.filter_by_7d;
      default:
        return function () {
          return true;
        };
    }
  }

  render() {
    const {
      sorting,
      filter,
      filter_date,
      showFilter,
      showUsersList,
      newMessages,
    } = this.state;
    return (
      <div
        className="ChatForm"
        style={{
          opacity: !this.state.isOpened ? "0" : "1",
          transition: "all .2s",
          display: !this.state.isOpened ? "none" : "flex",
        }}
      >
        <div
          className="ChatFormShowUsersListBtn"
          title="Список чатов"
          onClick={this.toggleUsersList}
        >
          <PeopleCircleSharp
            color={newMessages > 0 ? "#df0000" : "#707070"}
            height="30px"
            width="30px"
          />
        </div>
        <div
          className="ChatFormFilterBtn"
          title="Фильтр"
          onClick={this.toggleFilter}
        >
          <FilterCircleSharp color="#707070" height="30px" width="30px" />
        </div>
        <div className="ChatFormHeader">
          {localStorage.getItem("mentor_chat_title") + this.state.chatUserName}
        </div>
        <div className="ChatFormCloseBtn" onClick={this.state.closeFunc}>
          <CloseCircleSharp color="#FFFFFF" height="30px" width="30px" />
        </div>
        <div className={["UsersList", showUsersList ? "" : "hidden"].join(" ")}>
          <div
            className={[
              "UsersListFilterPanel",
              showFilter ? "" : "hidden",
            ].join(" ")}
          >
            <div className="UsersListFilterContainer">
              <div
                className={[
                  "UsersListFilterButton",
                  filter_date === "1д." ? "UserListFilterButtonSelected" : "",
                ].join(" ")}
                title="За сутки"
                onClick={this.set_filter_date("1д.")}
              >
                <TimeOutline color="#707070" height="28px" width="28px" />
                1д.&nbsp;
              </div>
              <div
                className={[
                  "UsersListFilterButton",
                  filter_date === "2д." ? "UserListFilterButtonSelected" : "",
                ].join(" ")}
                title="За двое суток"
                onClick={this.set_filter_date("2д.")}
              >
                <TimeOutline color="#707070" height="28px" width="28px" />
                2д.&nbsp;
              </div>
              <div
                className={[
                  "UsersListFilterButton",
                  filter_date === "7д." ? "UserListFilterButtonSelected" : "",
                ].join(" ")}
                title="За сем дней"
                onClick={this.set_filter_date("7д.")}
              >
                <TimeOutline color="#707070" height="28px" width="28px" />
                7д.&nbsp;
              </div>
              <div
                className={[
                  "UsersListFilterButton",
                  filter_date === "Всё" ? "UserListFilterButtonSelected" : "",
                ].join(" ")}
                title="За всё время"
                onClick={this.set_filter_date("Всё")}
              >
                <TimeOutline color="#707070" height="28px" width="28px" />
                Все&nbsp;
              </div>
            </div>
            <div className="UsersListFilterContainer">
              <input
                type="text"
                class="UserListFilterInput"
                id="MentorChatUsersFilterInput"
                placeholder="ФИО или текст"
                onKeyUp={this.set_filter_text(filter)}
              ></input>
            </div>
            <div className="UsersListFilterContainer">
              <div
                className={[
                  "UsersListFilterButton",
                  sorting === "date" ? "UserListFilterButtonSelected" : "",
                ].join(" ")}
                title="По времени последнего сообщения"
                onClick={this.set_sorting("date")}
              >
                <AlarmOutline color="#707070" height="28px" width="28px" />
              </div>
              <div
                className={[
                  "UsersListFilterButton",
                  sorting === "abc_desc" ? "UserListFilterButtonSelected" : "",
                ].join(" ")}
                title="По алфавиту по убыванию"
                onClick={this.set_sorting("abc_desc")}
              >
                <ArrowDownCircleOutline
                  color="#707070"
                  height="28px"
                  width="28px"
                />
              </div>
              <div
                className={[
                  "UsersListFilterButton",
                  sorting === "abc_asc" ? "UserListFilterButtonSelected" : "",
                ].join(" ")}
                title="По алфавиту по возрастанию"
                onClick={this.set_sorting("abc_asc")}
              >
                <ArrowUpCircleOutline
                  color="#707070"
                  height="28px"
                  width="28px"
                />
              </div>
            </div>
          </div>
          <div className="UsersListFilterContainer">
            {filter_date !== "Всё" ? "За последние " + filter_date + ":" : ""}
          </div>
          {this.state.chats
            .filter(this.filter_users_list_date(filter_date))
            .filter(this.filter_text)
            .sort(this.sort_users_list(sorting))
            .sort(this.sort_by_new_messages)
            .map((item) => (
              <ChatUser
                key={item.chat_id}
                chatId={item.chat_id}
                chatSelected={this.state.chatSelected}
                userName={item.user_name}
                userId={item.user_id}
                lastMessageText={item.last_message.text || ""}
                lastMessageTime={item.last_message.ts || 0}
                newMessages={item.new_messages || 0}
                isSelected={item.chat_id == this.state.chatId}
                selectChat={this.selectChat}
                closeUsersList={this.closeUsersList}
                mentorChatApiRoot={this.props.mentorChatApiRoot}
              ></ChatUser>
            ))}
          <div className="ChatUsersListFiller"></div>
        </div>
        <Chat
          mentorChatApiRoot={this.props.mentorChatApiRoot}
          chatSelected={this.state.chatSelected}
          chatId={this.state.chatId}
          isOpened={this.state.isOpened}
          allowed_mime={this.props.allowed_mime}
        ></Chat>
      </div>
    );
  }
}

export default ChatForm;
